import React from 'react';

import { IconProps } from './types';

export const CellBellIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M16.25 19.3984C16.2034 21.2561 14.7647 22.75 13 22.75C11.2058 22.75 9.75 21.2097 9.75 19.3053"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M21.2562 15.5687C20.7356 15.1667 20.3506 14.5658 20.2744 13.8717C19.5 6.5 16.5843 3.25 13 3.25C9.4157 3.25 6.5 6.5 5.7256 13.8717C5.6494 14.5658 5.2643 15.1667 4.7438 15.5687C4.3037 15.903 4.0625 16.2711 4.0625 16.6563C4.0625 18.2262 8.0658 19.5 13 19.5C17.9342 19.5 21.9375 18.2262 21.9375 16.6563C21.9375 16.2711 21.6963 15.903 21.2562 15.5687Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M4.0625 7.3125C4.5534 5.2178 5.806 3.4743 7.3125 2.4375"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M21.9375 7.3125C21.4466 5.2178 20.194 3.4743 18.6875 2.4375"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
